<template>
    <v-main>
        <top-bar
            :height="'48vh'"
            title="系统参数"
            addTitle="添加"
            :loading="loading"
            :isShowRefresh="true"
            @refresh="refresh"
            @add="add"
            @search="search"
        />
        <v-container fluid class="mt-n6">
            <v-data-table
                fixed-header
                :headers="headers"
                :items="systemList"
                :loading="loading"
                loading-text="数据加载中..."
                disable-sort
                :server-items-length="totalCount"
                :options.sync="options"
                :footer-props="footerProps"
                no-data-text="未查询到数据"
                :dark="theme.tableDark"
            >
			<template v-slot:item.name="{ item }">
			    <div class="textOver" style="width: 10rem">
			        <el-link
			            type="primary"
			            icon="el-icon-view el-icon--right"
			            class="ml-3"
			            @click="showDetails(item)"
			        >
			            {{ item.name }}
			        </el-link>
			    </div>
			</template>
			</v-data-table>
        </v-container>
        <v-dialog
            scrollable
            v-model="showDialog"
            :persistent="true"
            width="40em"
            overlay-color="#262626"
        >
            <SystemForm v-if="isClick" @cancel="cancel" @refresh="refresh" :isAdd="isAdd" :systemData="systemData" />
        </v-dialog>
    </v-main>
</template>
<script>
import util from "@/util";
import TopBar from "@/components/TopBar";
import SystemForm from "@/components/Form/SystemForm";
import store from "@/store";
import { mapState } from "vuex";
export default {
    name: "SystemList",
    components: {
        TopBar,
        SystemForm,
    },
    data() {
        return {
			showDialog: false,
            loading: false,
            isAdd: false,
            systemList: [],
            headers: [
                { text: "名称", value: "name" },
                { text: "信息", value: "info" },
            ],
            totalCount: 1000,
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            options: {}, //外部控制分页
			systemData: {},
			isClick: true
        };
    },
    watch: {
        // 刷新参数
        options: {
            handler(val) {
                this.getSystemList();
            },
            deep: true,
        },
		systemData() {
		    this.isClick = false;
		    this.$nextTick(() => {
		        this.isClick = true;
		    });
		},
    },
    computed: {
        ...mapState(["theme"]),
    },
    methods: {
        async refresh() {
            await this.getSystemList();
        },
        async getSystemList() {
			this.loading = true;
			let that = this;
            const { page, itemsPerPage } = this.options;
            let from = (page - 1) * itemsPerPage;
            let limit = itemsPerPage;
            let params = {
                postData: {
                    from: from,
                    limit: limit,
                },
				callbackOk:(data)=> {
					console.log(data)
					that.systemList = data;
					that.loading = false;
				},
				callbackErr: ()=> {
					that.loading = false;
				}
            };
			console.log(params)
            await store.dispatch("getSystemList", params);
        },
        add() {
			this.showDialog = true;
            this.isAdd = true;
        },
        cancel() {
            this.isAdd = false;
			this.showDialog = false;
			this.systemData = {};
        },
		/*打开互联互通详细信息*/
		showDetails(item) {
			this.showDialog = true;
		    this.isAdd = false;
		    this.systemData = item;
		},
        search() {},
    },
};
</script>
